export default __webpack_public_path__ + "static/media/m_ceoLanding05.3b3d9052.png";